import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
export default {
	data: () => ({
		loading: false,
	}),

	props: {
		modelValue:			{ type: Object, default: () => {} },
		required:			{ type: Boolean, default: false },
		maxWidth:			{ type: [Number, String], default: 400 },
		width:				{ type: [Number, String], default: '100%' },
		visible:			{ type: Boolean, default: false },
	},

	computed: {
		...mapGetters('Claim', [ 'claim', 'step' ]),
		
		item: {
			get() 		{ return this.modelValue },
			set(val) 	{ this.$emit('update:modelValue', val) }
		},

		title() {
			//return this.item?.title ? this.item.title : "Заголовок"
			return this.item?.title ? this.item.title : this.item.name
		},
		titleClass() {
			return this.item?.titleClass ? this.item.titleClass : "font-weight-bolt text-secondary text-wrap"
		},
		subtitle() {
			return this.item?.subtitle ? this.item.subtitle : null //"Надати обов'язково!"
		},
		subtitleClass() {
			return this.item?.subtitleClass ? this.item.subtitleClass : null //"text-red"
		},
		text() {
			//return this.item?.text ? this.item.text : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
			return this.item?.text ? this.item.text : null
		},

		rules() {
			return {
				required: (value) => !!value || this.$vuetify.locale.t('$vuetify.rule.required'),
				mustBeSelected: (value) => typeof(value) === "undefined" || value === null || value?.id>0 || this.$vuetify.locale.t('$vuetify.rule.mustBeSelected'),
				
				code: (value) => {
					const pattern = /^([a-zA-Z'\-]+)/
					return (value === null || value.length == 0 || value.length > 32 || pattern.test(value)) || this.$vuetify.locale.t('$vuetify.rule.code', [128])
				},
				name: (value) => {
					const pattern = /^([a-zA-Zа-яА-ЯЇї'\-]+)/
					return (value && value.length <= 10 && pattern.test(value)) || 'Name is not correct'
					//return value === null || ( value.length <= 10 && pattern.test(value)) || 'Name is not correct'
				},
				date: (value) => {
					//console.log('form.mixin', 'rules.date', 'value', value)
					return (value === null || value?.length == 0 || moment(value, "DD.MM.YYYY", true).isValid() || moment(value, "YYYY-MM-DD", true).isValid()) || 'Date is not correct'
				},

				datetime: (value) => {
					return (value === null || value.length == 0 || moment(value, "YYYY-MM-DDTHH:mm", true).isValid()) || 'Date is not correct'
				},

				email: (value) => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					return pattern.test(value) || this.$vuetify.locale.t('$vuetify.rule.email')//'Некоректний e-mail.'
				},
				phone: (value) => {
					const pattern = /^\+?3?8?(0\d{9})$/
					//return (value === null || value?.length == 0 || pattern.test(value)) || 'Номер телефону не вірний (+380961112233)'
					return pattern.test(value) || 'Номер телефону не вірний (+380961112233)'
				},
				personsname: (value) => {
					const pattern = /^([a-zA-Zа-яА-ЯЇї'\- ]+)/
					return (value && value.length <= 10 && pattern.test(value)) || this.$vuetify.locale.t('$vuetify.rule.personsname')//'Name is not correct'
				},

				ofertaagree: (value) => value === true || this.$vuetify.locale.t('$vuetify.rule.required'),
				ClaimNumber: (value) => !!value && value.length === 5 || "OTP must be 6 digits.",
			}
		},

		configuration() {
			let result = 'КАСКО' // КАСКО | ОСЦПВВНТЗ ТЗ | ОСЦПВВНТЗ Пряме | ОСЦПВВНТЗ Майно
			if(this.item && this.item.hasOwnProperty('settlementNotice')) {
				if(this.item.settlementNotice.hasOwnProperty('configName')) {
					result = this.item.settlementNotice.configName
				}
			}
			
			//console.log('mixin', this.$options.name, 'configuration','result', result)

			return result;
		},
	},

	created() {
		/* const requireItem = require.context("@/components/window", false, /[A-Z]\w+\.(vue|js)$/);
		requireItem.keys().forEach(fileName => {
			const componentConfig = requireItem(fileName);
			const componentName = fileName.split("/").pop().split(".")[0];
			this.$options.components[componentName] = componentConfig.default;
		}); */
	},

	/* watch: {
		
	}, */

	methods: {
		...mapActions([ 'showMessage' ]),
		...mapActions('Claim', ['setClaim', 'setStep', 'previousStep', 'nextStep']),

		validate() {
			//console.log(this.$options.name, 'validate', this.$refs.form?.validate())
			return this.$refs.form?.validate()
		},

		/* onSnackbar(text) {
			//console.log(this.$options.name, 'onSnackbar','snackbar', this.snackbar)
			//this.snackbar.visible = false
			this.snackbar.visible = true
			this.snackbar.text = text
		}, */

		/* addPhoto(data, type) {
			//console.log(this.$options.name, 'addPhoto','data', data)

			let 
				file 	= data.hasOwnProperty('file') ? data.file : null
				,source = data.hasOwnProperty('source') ? data.source : null
				,exif 	= data.hasOwnProperty('exif') ? data.exif : null
			;

			//console.log(this.$options.name, 'addPhoto','file', file)

			this.checkFile(file, (file) => {
				let formData = new FormData();

				formData.append('file', file);
				formData.append('name', file.name);
				formData.append('size', file.size);
				formData.append('format', file.type);
				formData.append('type', type);
				formData.append('source', source);
				//formData.append('exif', exif);
				if(exif) {
					formData.append('exif', JSON.stringify(exif));
				}

				//console.log(this.$options.name, 'addPhoto','formData', formData)

				if(this.item?.id) {
					this.loadings[type] = true
					var that = this
					axios.post(`/insurance/claim/application/${this.item.id}/media`, formData, {
						headers: {
						  "Content-Type": "multipart/form-data"
						}
					}).then(response => {
						//console.log(that.$options.name, 'addPhoto','response.data', response.data)
						that.item.medias.push(response.data)
					}, error => {
						console.log('error', error)
	
						//that.snackbar.visible 	= true;
						//that.snackbar.text 		= error.response.data.message;
						//that.snackbar.color 	= null;
					}).finally(() => {
						this.loadings[type] = false
					});
				}
			})
		}, */

		/* removePhoto(e) {
			if(e) {
				//console.log(this.$options.name, 'removePhoto', 'e', e)
				//console.log(this.$options.name, 'removePhoto', 'photos', this.item.photos)

				//const index = this.item.photos.indexOf(e)
				//this.item.photos.splice(index, 1);

				///insurance/claim/application/media/{id}", methods={"DELETE"})
				let id = e?.id;
				let type = e?.type?.code;

				//console.log(this.$options.name, 'removePhoto', 'id', id, 'type', type)

				if(id) {
					this.loadings[type] = true
					var that = this
					axios.delete(`/insurance/claim/application/media/${id}`).then(response => {
						//console.log(that.$options.name, 'removePhoto','response.data', response.data)

						const index = that.item.medias.indexOf(e)
						that.item.medias.splice(index, 1);
					}, error => {
						console.log(error)
					}).finally(() => {
						this.loadings[type] = false
					});
				} else {
					const index = this.item.medias.indexOf(e)
					this.item.medias.splice(index, 1);
				}
			}
		}, */

		/* checkFile(file, clallback) {
			if(file) {
				if(file.size > 2*1024*1024) {
					//console.log(this.$options.name, 'checkFile', `Недопустимий розмір файлу ${file.size}. Розмір файлу повинен бути не більше 2 Мб`)
					//this.onSnackbar(`Недопустимий розмір файлу ${file.size}. Розмір файлу повинен бути не більше 2 Мб`)
					//return
					let that = this
					var img = new Image();
					img.src = URL.createObjectURL(file);
					img.onload = function() {
						// Image is loaded; now, resize it
						var canvas = that.resizeImage(img);

						//console.log(that.$options.name, 'checkFile', 'img.width', img.width, 'img.height', img.height)

						const dataUrl = canvas.toDataURL('image/jpeg');
						const resizedImage = that.dataURLToBlob(dataUrl);

						const fullQuality = canvas.toDataURL("image/jpeg", 1.0);
						const mediumQuality = canvas.toDataURL("image/jpeg", 0.5);
						const lowQuality = canvas.toDataURL("image/jpeg", 0.1);

						clallback(fullQuality)
						//clallback(dataUrl)
						//clallback(resizedImage)
					};
				} else {
					//console.log(this.$options.name, 'checkFile', `Розмір файлу ${file.size}`)
					
					clallback(file)
				}
			}
		}, */

		/**
		 * Resizing the Image
		 * https://cloudinary.com/guides/bulk-image-resize/transform-your-visuals-how-to-resize-an-image-in-javascript
		 * @param image 
		 */
		resizeImage(image) {
			//console.log(this.$options.name, 'resizeImage', 'image.width', image.width, 'image.height', image.height)

			var maxWidth = 800; // Define the maximum width of the image
			var maxHeight = 600; // Define the maximum height of the image
			var width = image.width;
			var height = image.height;

			// Calculate the new dimensions, maintaining the aspect ratio
			if (width > height) {
				if (width > maxWidth) {
					height *= maxWidth / width;
					width = maxWidth;
				}
			} else {
				if (height > maxHeight) {
					width *= maxHeight / height;
					height = maxHeight;
				}
			}

			// Set the canvas dimensions to the new dimensions
			var canvas = document.createElement('canvas');
			canvas.width = width;
			canvas.height = height;

			// Draw the resized image on the canvas
			var ctx = canvas.getContext('2d');
			ctx.drawImage(image, 0, 0, width, height);

			//console.log(this.$options.name, 'resizeImage', 'canvas.width', canvas.width, 'canvas.height', canvas.height)
			//console.log(this.$options.name, 'resizeImage', 'image.width', image.width, 'image.height', image.height)

			// Insert the canvas into the DOM or use it otherwise
			//document.body.appendChild(canvas);

			return canvas
		},

		/** 
		 * Utility function to convert a canvas to a BLOB
		 * 
		 */
		dataURLToBlob(dataURL) {
			var BASE64_MARKER = ';base64,';
			if (dataURL.indexOf(BASE64_MARKER) == -1) {
				var parts = dataURL.split(',');
				var contentType = parts[0].split(':')[1];
				var raw = parts[1];

				return new Blob([raw], {type: contentType});
			}

			var parts = dataURL.split(BASE64_MARKER);
			var contentType = parts[0].split(':')[1];
			var raw = window.atob(parts[1]);
			var rawLength = raw.length;

			var uInt8Array = new Uint8Array(rawLength);

			for (var i = 0; i < rawLength; ++i) {
				uInt8Array[i] = raw.charCodeAt(i);
			}

			return new Blob([uInt8Array], {type: contentType});
		},

		/**
		 * EXIF meta data from image files
		 * https://github.com/exif-js/exif-js
		 * https://www.npmjs.com/package/exif-js
		 */
		onExif(file) {
			//console.log(this.$options.name, 'onExif', 'file', file)

			//let bl = EXIF.readFromBinaryFile(file)
			//console.log(this.$options.name, 'onExif', 'bl', bl)

			let that = this
			var img = file
			EXIF.getData(img, function() {
				var make = EXIF.getTag(this, "Make");
				var model = EXIF.getTag(this, "Model");
				var allMetaData = EXIF.getAllTags(this);
				//var makeAndModel = document.getElementById("makeAndModel");
				//makeAndModel.innerHTML = `${make} ${model}`;

				console.log(that.$options.name, 'onExif', 'make', make)
				console.log(that.$options.name, 'onExif', 'model', model)
				console.log(that.$options.name, 'onExif', 'allMetaData', allMetaData)
			});
		},
		
	},
}